export default __webpack_public_path__ + "static/media/valor1.76f09380.png";